<template functional>
  <span :class="$options.methods.getClasses(props)">
    <span v-if="$options.methods.shouldHideEmptyPrice(props) || $options.methods.shouldHide(props)" />
    <span v-else-if="$options.methods.isEmpty(props.row[props.column.field])">
      <template v-if="props.column.meta.emptyValue">
        {{ props.column.meta.emptyValue }}
      </template>
      <template v-else>
        kostenfrei
      </template>
    </span>
    <span v-else>
      {{ props.row[props.column.field] | price(props.column.meta ? (props.column.meta.symbol || '€') : '€') }}
    </span>
    <div
      v-if="props.column.meta && props.column.meta.afterSlot && !!props.column.meta.afterSlot(props.row)"
      v-html="props.column.meta.afterSlot(props.row)"
    />
  </span>
</template>

<script>
import get from 'lodash/get'
import { isEmpty } from '@/helpers/utils'

export default {
  name: 'MiaDatatablePriceColumn',

  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },

    column: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  methods: {
    shouldHide({ row, column }) {
      const { hide } = column.meta || {}

      if (!hide) return false

      return typeof hide === 'function' ? hide() : hide
    },

    shouldHideEmptyPrice({ row, column }) {
      const { hideEmpty } = column.meta || {}

      if (!hideEmpty || isEmpty(row[column.field])) return false

      const parsedPrice = parseFloat(row[column.field])

      return Number.isNaN(parsedPrice) || parsedPrice === 0.0
    },

    getClasses({ column, row }) {
      const classes = get(column, 'meta.class', '')

      if (typeof classes === 'function') {
        return classes(row)
      }

      return classes
    },

    isEmpty
  }
}
</script>
